import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import REST from '../Shared/REST';
import ProgressBox from "../ProgressModalComponent/ProgressBox";
import InlineProgressBox from "../ProgressModalComponent/InlineProgressBox";

import logo_picturenaming from '../assets/images/app-picturenaming.png';
import logo_kidspeak from '../assets/images/logo_kidspeak.png';
import logo_wordmark from '../assets/images/logo_wordmark.png';
import logo_slashtest from '../assets/images/logo_slashtest.png';
import logo_wordsignsay from '../assets/images/app-wordsignsay.png';
import logo_kidsign from '../assets/images/app-kidsign.png';
import logo_copyright from '../assets/images/app-copyright.png';
import logo_maze from '../assets/images/logo_maze.png';
import icon_datachart from '../assets/images/data-chart.png';
import {updateStudentAppsStatus} from "./actions";
import {connect} from "react-redux";
import {updateStudent} from "../TeachersComponent/actions";
import Helpers from "../Shared/Helpers";
import Modal from "../TeachersComponent/Students";
import ReactModal from 'react-modal';

const customStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '45%'
    }
};

class MyProfileComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            noDataModel:false,
            refresh: false
        }
        this.handleMazeClick = this.handleMazeClick.bind(this);
        this.handleSlashTestClick = this.handleSlashTestClick.bind(this);
        this.handleWordMarkClick = this.handleWordMarkClick.bind(this);
        this.handleKidSpeakClick = this.handleKidSpeakClick.bind(this);
        this.handlePictureNamingClick = this.handlePictureNamingClick.bind(this);
        this.handleCopyRightClick = this.handleCopyRightClick.bind(this);
        this.handleWordSignSayClick = this.handleWordSignSayClick.bind(this);
        this.handleKidSignClick = this.handleKidSignClick.bind(this);
        this.handleNoDataClose = this.handleNoDataClose.bind(this);
    }

    async componentDidMount() {


        await REST.authWithToken().then(async (res) => {
            let student;
            if (this.props.userRole === "parent") {
                student = this.props.currentStudent;
            } else {
                student = res.body;
                student.userId = res.body.id;
                student.user = {...res.body};
                student.personalUse = true;
            }
            if (student) {
                await this.props.updateStudent(student);
                await REST.getStudentAppStatus(student.userId).then(async (res) => {
                    await this.props.updateStudentAppStatus(res.body);
                });
            }
        });

    }

    async componentDidUpdate(prevProps) {
        if(prevProps !== this.props) {
            let student;
            student = this.props.currentStudent;
            if (student) {
                await this.props.updateStudent(student);
            }
            await this.setState({refresh: this.props.refresh});
        }
    }

    async handleMazeClick(event) {
        await REST.checkStudentData(this.props.student.userId, "Maze").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/maze');
            }
        });
    }

    async handleWordMarkClick(event) {
        await REST.checkStudentData(this.props.student.userId, "Maze").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/wordmark');
            }
        });
    }

    async handleSlashTestClick(event) {
        await REST.checkStudentData(this.props.student.userId, "Slash").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/slashtest');
            }
        });
    }

    async handleKidSpeakClick(event) {
        await REST.checkStudentData(this.props.student.userId, "KidSpeak").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/kidspeak');
            }
        });
    }

    async handlePictureNamingClick(event) {
        await REST.checkStudentData(this.props.student.userId, "PictureNaming/Computer").then(res=> {
            if (res.body === 0) {
                this.setState({
                    pnTypeModel:false,
                    noDataModel:true

                });
            } else {
                this.props.history.push('/teacher/student/data/picturenaming/computer');
            }
        });
    }

    async handleCopyRightClick(event) {
        await REST.checkStudentData(this.props.student.userId, "CopyRight").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/copyright');
            }
        });
    }

    async handleWordSignSayClick(event) {
        await REST.checkStudentData(this.props.student.userId, "WordSign/Say").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/wordsignsay');
            }
        });
    }

    async handleKidSignClick(event) {
        await REST.checkStudentData(this.props.student.userId, "KidSign").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/kidsign');
            }
        });
    }

    async handleNoDataClose(event){
        this.setState({
            noDataModel:false
        });
    }

    render() {
        let sampleBestScores = {
            id: 2047,
            userId: 2421,
            createdAt: '2019-02-11T22:32:27.358Z',
            updatedAt: '2020-02-08T02:14:06.345Z',
            mazeLevel: 5,
            mazeScore: 1,
            slashLevel: 3,
            slashScore: 1,
            ksLevel: 1,
            ksScore: 1,
            pnLevel: 1,
            pnScore: 1,
            crLevel: 1,
            crScore: 1,
            wssLevel: 1,
            wssScore: 1,
            kssLevel: 1,
            kssScore: 1,
        }

        let currentApps;
        if(this.props.currentApps){
            currentApps = this.props.currentApps;
        }else if (this.props.apps.bestScores){
            currentApps = this.props.apps;
        }else{
            currentApps = {bestScores:sampleBestScores};
        }

        let bestScores = currentApps.bestScores;

        let currentStudent;

        if(this.props.studentUser){
            currentStudent = this.props.studentUser;
        }else{
            currentStudent = this.props.currentStudent;
        }


        let {allowedApps, filteredApps, finishedApps} = Helpers.filterApps(currentStudent,currentApps);

        return (
            <div className={"container"}>
                <div className={"center-block"}>
                    <div className={""}>
                        <div style={{cursor:'pointer'}} className={"row bgGrey"} style={{background:'#c3c3c3'}}>
                            <div className={"row centerOneLineVertically"}>
                                <div className={"col-md-12 col-sm-12 noPaddingLR"}>
                                <div className={"col-md-3 col-sm-4 padding15"}>
                                    <div className="taskProgressIcon">
                                        <h3 className={"myProfileFont"} style={{
                                            width: "auto",
                                            margin: 0,
                                            marginLeft: 20,
                                            textAlign: "left"
                                        }}>App Name</h3>
                                    </div>
                                </div>
                                <div className={"col-md-9 col-sm-8 padding15 borderLeftWhite"}>
                                    <div className="taskProgressIcon">
                                        <h3 className={"myProfileFont"} style={{
                                            width: "auto",
                                            margin: 0,
                                            marginLeft: 35,
                                            textAlign: "left"
                                        }}>My Progress</h3> <span style={{position:'relative', top:12, marginLeft:10}}>(Click icons below for Data Charts)</span> <img src={icon_datachart} style={{width:25,position:'relative',top:10,marginLeft:15}}/>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {allowedApps.includes("picturenaming") ?
                        <div onClick={this.handlePictureNamingClick} style={{cursor:'pointer'}} className={"row bgWhite1"}>
                            <div className={"row centerOneLineVertically"}>
                                <div className={"col-md-12 col-sm-12 noPaddingLR"}>
                                <div className={"col-md-3 col-sm-4 padding15"}>
                                    <div className="taskProgressIcon paddingL15">
                                        <a className="" data-toggle="pill" onClick={this.handlePictureNaming}>
                                            <img src={logo_picturenaming} className="ico-m" style={{height: 44}}
                                                 alt="Picture Naming" border="0"/>
                                        </a>
                                        <h3 className={"myProfileFont"} style={{
                                            width: "auto",
                                            margin: 0,
                                            marginLeft: 10,
                                            textAlign: "left"
                                        }}>PictureNaming</h3>
                                    </div>
                                </div>
                                <div className={"col-md-9 col-sm-8 padding15 borderLeftWhite"}>
                                    <InlineProgressBox noDescription={"true"} maxLevel={3} level={bestScores.pnLevel} badgeNo={7}/>
                                </div>
                                </div>
                            </div>
                        </div>
                        : null
                    }
                    {allowedApps.includes("wordsignsay") ?
                        <div onClick={this.handleWordSignSayClick} style={{cursor:'pointer'}}  className={"row bgGrey1"}>
                            <div className={"row centerOneLineVertically"} >
                                <div className={"col-md-12 col-sm-12 noPaddingLR"}>
                                <div className={"col-md-3 col-sm-4 padding15"}>
                                    <div className="taskProgressIcon paddingL15">
                                        <a className="" data-toggle="pill" onClick={this.handleWordSignSay}>
                                            <img src={logo_wordsignsay} className="ico-m" style={{height: 44}}
                                                 alt="Word Sign/Say" border="0"/>
                                        </a>
                                        <h3 className={"myProfileFont"} style={{width: "auto", margin: 0, marginLeft: 10, textAlign: "left"}}>Word
                                            Sign/Say</h3>
                                    </div>
                                </div>
                                <div className={"col-md-9 col-sm-8 padding15 borderLeftWhite"}>
                                    <InlineProgressBox noDescription={"true"} level={bestScores.wssLevel} maxLevel={1} badgeNo={4}/>
                                </div>
                            </div>
                            </div>
                        </div>
                        : null
                    }
                    {allowedApps.includes("copyright") ?
                        <div onClick={this.handleCopyRightClick} style={{cursor:'pointer'}} className={"row bgWhite1"}>
                            <div className={"row centerOneLineVertically"}>
                                <div className={"col-md-12 col-sm-12 noPaddingLR"}>
                                <div className={"col-md-3 col-sm-4 padding15"}>
                                    <div className="taskProgressIcon paddingL15">
                                        <a className="" data-toggle="pill" onClick={this.handlePictureNaming}>
                                            <img src={logo_copyright} className="ico-m" style={{height: 44}}
                                                 alt="CopyRight"
                                                 border="0"/>
                                        </a>
                                        <h3 className={"myProfileFont"} style={{
                                            width: "auto",
                                            margin: 0,
                                            marginLeft: 10,
                                            textAlign: "left"
                                        }}>CopyRight</h3>
                                    </div>
                                </div>
                                <div className={"col-md-9 col-sm-8 padding15 borderLeftWhite"}>
                                    <InlineProgressBox noDescription={"true"} level={bestScores.crLevel} maxLevel={6} badgeNo={1}/>
                                </div>
                                </div>
                            </div>
                        </div>
                        : null
                    }
                    {allowedApps.includes("slash") ?
                        <div onClick={this.handleSlashTestClick} style={{cursor:'pointer'}} className={"row bgGrey1"}>
                            <div className={"row centerOneLineVertically"}>
                                <div className={"col-md-12 col-sm-12 noPaddingLR"}>
                                <div className={"col-md-3 col-sm-4 padding15"}>
                                    <div className="taskProgressIcon paddingL15">
                                        <a className="" data-toggle="pill" onClick={this.handleSlashTest}>
                                            <img src={logo_slashtest} className="ico-m" style={{height: 44}}
                                                 alt="Slashtest"
                                                 border="0"/>
                                        </a>
                                        <h3 className={"myProfileFont"} style={{
                                            width: "auto",
                                            margin: 0,
                                            marginLeft: 10,
                                            textAlign: "left"
                                        }}>Slash</h3>
                                    </div>
                                </div>
                                <div className={"col-md-9 col-sm-8 padding15 borderLeftWhite"}>
                                    <InlineProgressBox noDescription={"true"} level={bestScores.slashLevel}
                                                       maxLevel={8}  badgeNo={3}/>
                                </div>
                                </div>
                            </div>
                        </div>
                        : null
                    }
                    {allowedApps.includes("kidspeak") ?
                        <div onClick={this.handleKidSpeakClick} style={{cursor:'pointer'}} className={"row bgWhite1"}>
                            <div className={"row centerOneLineVertically"}>
                                <div className={"col-md-12 col-sm-12 noPaddingLR"}>
                                <div className={"col-md-3 col-sm-4 padding15"}>
                                    <div className="taskProgressIcon paddingL15">
                                        <a className="" data-toggle="pill" onClick={this.handlePictureNaming}>
                                            <img src={logo_kidspeak} className="ico-m" style={{height: 44}}
                                                 alt="KidSpeak"
                                                 border="0"/>
                                        </a>
                                        <h3 className={"myProfileFont"} style={{
                                            width: "auto",
                                            margin: 0,
                                            marginLeft: 10,
                                            textAlign: "left"
                                        }}>KidSpeak</h3>
                                    </div>
                                </div>
                                <div className={"col-md-9 col-sm-8 padding15 borderLeftWhite"}>
                                    <InlineProgressBox noDescription={"true"} level={bestScores.ksLevel} maxLevel={6} badgeNo={2}/>
                                </div>
                            </div>
                            </div>
                        </div>
                        : null
                    }
                    {allowedApps.includes("maze") ?
                        <div onClick={this.handleMazeClick} style={{cursor:'pointer'}} className={"row bgGrey1"}>
                            <div className={"row centerOneLineVertically"}>
                                <div className={"col-md-12 col-sm-12 noPaddingLR"}>
                                <div className={"col-md-3 col-sm-4 padding15"}>
                                    <div className="taskProgressIcon paddingL15">
                                        <a className="" data-toggle="pill" onClick={this.handleMaze}>
                                            <img src={logo_maze} className="ico-m" style={{height: 44}} alt="Maze"
                                                 border="0"/>
                                        </a>
                                        <h3 className={"myProfileFont"} style={{width: "auto", margin: 0, marginLeft: 10, textAlign: "left"}}
                                        >Maze</h3>
                                    </div>
                                </div>
                                <div className={"col-md-9 col-sm-8 padding15 borderLeftWhite"}>
                                    <InlineProgressBox noDescription={"true"} level={bestScores.mazeLevel}
                                                       maxLevel={12} badgeNo={5}/>
                                </div>
                            </div>
                            </div>
                        </div>
                        : null
                    }
                    {allowedApps.includes("kidsign") ?
                        <div onClick={this.handleKidSignClick} style={{cursor:'pointer'}} className={"row bgWhite1"}>
                            <div className={"row centerOneLineVertically"}>
                                <div className={"col-md-12 col-sm-12 noPaddingLR"}>
                                    <div className={"col-md-3 col-sm-4 padding15"}>
                                        <div className="taskProgressIcon paddingL15">
                                            <a className="" data-toggle="pill" onClick={this.handleKidSign}>
                                                <img src={logo_kidsign} className="ico-m" style={{height: 44}} alt="KidSign"
                                                     border="0"/>
                                            </a>
                                            <h3 className={"myProfileFont"} style={{
                                                width: "auto",
                                                margin: 0,
                                                marginLeft: 10,
                                                textAlign: "left"
                                            }}>KidSign</h3>
                                        </div>
                                    </div>
                                    <div className={"col-md-9 col-sm-8 padding15 borderLeftWhite"}>
                                        <InlineProgressBox noDescription={"true"} level={bestScores.kssLevel}
                                                           maxLevel={12} badgeNo={6}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null
                    }
                    {allowedApps.includes("wordmark") ?
                        <div onClick={this.handleWordMarkClick} style={{cursor:'pointer'}} className={"row bgGrey1"}>
                            <div className={"row centerOneLineVertically"}>
                                <div className={"col-md-12 col-sm-12 noPaddingLR"}>
                                <div className={"col-md-3 col-sm-4 padding15"}>
                                    <div className="taskProgressIcon paddingL15">
                                        <a className="" data-toggle="pill" onClick={this.handleWordMark}>
                                            <img src={logo_wordmark} className="ico-m" style={{height: 44}}
                                                 alt="WordMark"
                                                 border="0"/>
                                        </a>
                                        <h3 className={"myProfileFont"} style={{
                                            width: "auto",
                                            margin: 0,
                                            marginLeft: 10,
                                            textAlign: "left"
                                        }}>WordMark</h3>
                                    </div>
                                </div>
                                <div className={"col-md-9 col-sm-8 padding15 borderLeftWhite"}>
                                    <InlineProgressBox noDescription={"true"} level={1} maxLevel={1} badgeNo={0}/>
                                </div>
                                </div>
                            </div>
                        </div>
                        : null
                    }
                </div>
                <ReactModal isOpen={this.state.noDataModel} style={customStyle}>
                    <div className="modal-content content">
                        <div className="modal-header">
                            <div className="clearfix"></div>
                            <h2>No tasks completed yet.</h2>
                        </div>
                        <div className="modal-footer">
                            <a onClick={this.handleNoDataClose} className="handBtn"><span>Close</span></a>
                        </div>
                    </div>
                </ReactModal>
            </div>
        )
    }
}

const bindActionToProps = dispatch => {
    return {
        updateStudentAppStatus: async (results) => await dispatch(updateStudentAppsStatus(results)),
        updateStudent: async (student) => await dispatch(updateStudent(student)),
    };
};


const mapStateToProps = state => ({
    apps: state.studentReducer.apps,
    student: state.teacherReducer.student,
    tabNum: state.studentReducer.tabNum,
    studentUser: state.studentReducer.studentUser
});


export default connect(mapStateToProps, bindActionToProps)(withRouter(MyProfileComponent));
